import React from "react"
import PropTypes from "prop-types"

export const LeftArrow = ({ height = 24, width = 24, fill = "#272A34", ...props }) => (
  <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 8.5C0 4.08172 3.58172 0.5 8 0.5H16C20.4183 0.5 24 4.08172 24 8.5V16.5C24 20.9183 20.4183 24.5 16 24.5H8C3.58172 24.5 0 20.9183 0 16.5V8.5Z" fill="white"/>
    <path d="M14 16.5L10 12.5L14 8.5" stroke="#525455" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

LeftArrow.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string,
}